module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-40.24739b1.woff2";